import React from "react";
import { ResearchPackageEvidencePanels } from "../components/ResearchPackagePanels.jsx";

export function ResearchPackages() {
  return <ResearchPackageEvidencePanels />;
}
